import { Alert } from '@pms-digital/design-system';

interface AlerteLoginProps {
  id: string;
  message: string;
}

/**
 * Message above the form (L2): the `Alert` of the design system, danger tone (`role="alert"`, so
 * assistive technologies read it as soon as it appears). The `id` sits on the box around it: the
 * invalid fields point to it with `aria-describedby`, and the package's `Alert` takes no `id`.
 */
export function AlerteLogin({ id, message }: AlerteLoginProps) {
  return (
    <div id={id} className="mt-6">
      <Alert tone="danger">{message}</Alert>
    </div>
  );
}
